import React from 'react';
import PropTypes from 'prop-types';
export function ViewPageModal({ isOpen, onClose, onViewPage, onBackToList, message }) {
    const handleOverlayClick = (e) => {
        if (e.target.className === 'admin-modal-overlay') {
            onClose();
        }
    };
    if (!isOpen) return null;
    return (
        <div className="admin-modal-overlay" onClick={handleOverlayClick}>
            <div className="admin-modal">
                <button className="admin-modal-close" onClick={() => onClose()}>
                    <span className="material-symbols-rounded">close</span>
                </button>
                <h2 className="admin-modal-heading">
                    {message}
                </h2>
                <div className="admin-modal-button-wrap">
                    <button className="admin-modal-button" onClick={onViewPage}>
                        View Page
                    </button>
                    <button
                        className="admin-form-button power red"
                        onClick={onBackToList}
                    >
                        Back to List
                    </button>
                </div>
            </div>
        </div>
    );
} 
ViewPageModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onViewPage: PropTypes.func.isRequired,
    onBackToList: PropTypes.func.isRequired,
    message: PropTypes.string
};